"use client";

import dynamic from "next/dynamic";

import type { AccordionSlidesProps } from "./AccordionSlides";

const AccordionSlides = dynamic(() => import("./AccordionSlides"));

export default function AccordionSlidesWrapper(props: AccordionSlidesProps) {
  return <AccordionSlides {...props} />;
}
